import { Controller } from "stimulus";


export default class extends Controller {
  static targets = ["btn", "expandedBlock", "expandedBlockDesktop"];

  expandBlock() {
    this.btnTarget.classList.toggle('rotate');
    this.expandedBlockTarget.classList.toggle('opened');
    this.expandedBlockDesktopTarget.classList.toggle("opened");
  }

  
}
